import React from 'react';

import NewSkills from './Skills/NewSkills';

const resumeContent = [
  {
    jobPosition: `Software Developer`,
    jobType: `New Delhi`,
    jobDuration: `Dec 2023 - Present`,
    timeDuraton: `Intern`,
    compnayName: 'PyCray Technologies Private Limited',
    jobDescription: `Assisted in developing and implementing front-end interfaces using React, TypeScript for industry-standard applications. My key responsibilities included developing new applications as well as improving existing websites.  Participated in team meetings, contributing ideas for project enhancements and improvements.
    `,
    delayAnimation: '',
  },
  {
    jobPosition: `Software Engineer`,
    jobType: `New Delhi`,
    jobDuration: `Sep 2023 - Oct 2023`,
    timeDuraton: `Intern`,
    compnayName: 'Influence (M/s Target Solutions India, Target Inc. The US)',
    jobDescription: `Got the opportunity to contribute to industry-level applications while collaborating as an integral part of team. My primary focus has been on front-end development, leveraging web technologies such as React and Redux. My responsibilities have included identifying and resolving software defects and issues`,
    delayAnimation: '',
  },
  {
    jobPosition: `Web Developer`,
    jobType: `Noida`,
    jobDuration: `Aug 2022`,
    timeDuraton: `Intern`,
    compnayName: 'Mobisoft Technologies',
    jobDescription: `In this internship, I gained valuable hands-on experience and exposure to various aspects of web development. During this time, I actively participated in maintaining and building web applications using tech like HTML, CSS, JavaScript, ReactJS etc`,
    delayAnimation: '100',
  },
  {
    jobPosition: `Web Developer`,
    jobType: `Remote`,
    jobDuration: `Jul 2021 - Aug 2021`,
    timeDuraton: `Trainee`,
    compnayName: 'Brain Mentors Pvt Limited',
    jobDescription: ` Completed a comprehensive training program covering web development concepts, tools, and technologies, in- cluding HTML, CSS, JavaScript, and MERN Stack. Demonstrated the ability to work collaboratively with peers to build complex web applications, using best practices and effective project management techniques.`,
    delayAnimation: '200',
  },
];

const educatonContent = [
  {
    passingYear: '2019-2023',
    degreeTitle: 'B.Tech in Electronics & Communications Engineering',
    instituteName: "Bharati Vidyapeeth's College of Engineering",
  },
  {
    passingYear: '2017-2018',
    degreeTitle: '12th in PCM',
    instituteName: 'KSK Academy',
  },
  {
    passingYear: '2015-2016',
    degreeTitle: '10th',
    instituteName: 'Tinu Public School',
  },
];

const Resume = () => {
  return (
    <>
      <section id='resume' className='section'>
        <div className='container'>
          <div className='title'>
            <h3>Experience.</h3>
          </div>
          {/* End title */}
          <div className='resume-box'>
            {resumeContent.map((val, i) => (
              <div
                className='resume-row'
                key={i}
                data-aos='fade-up'
                data-aos-duration='1200'
                data-aos-delay={val.delayAnimation}
              >
                <div className='row'>
                  <div className='col-md-4 col-xl-3'>
                    <div className='rb-left'>
                      <h6>{val.jobPosition}</h6>
                      <label>{val.jobType}</label>
                      <p>{val.jobDuration}</p>
                      <div className='rb-time'>{val.timeDuraton}</div>
                    </div>
                  </div>
                  <div className='col-md-8 col-xl-9'>
                    <div className='rb-right'>
                      <h6>{val.compnayName}</h6>
                      <p>{val.jobDescription}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* separated */}
          <div
            className='separated'
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL + 'img/border-dark.png'
              })`,
            }}
          ></div>
          {/* End separated */}

          <div className='title'>
            <h3>Education & Skills</h3>{' '}
          </div>

          <div className='row align-items-center'>
            <div
              className='col-lg-4 m-15px-tb'
              data-aos='fade-up'
              data-aos-duration='1200'
            >
              <ul className='aducation-box'>
                {educatonContent.map((val, i) => (
                  <li key={i}>
                    <span>{val.passingYear}</span>
                    <h6>{val.degreeTitle} </h6>
                    <p>{val.instituteName}</p>{' '}
                  </li>
                ))}
              </ul>
            </div>
            {/* End .col */}

            <div
              className='col-lg-7 ml-auto m-15px-tb'
              data-aos='fade-up'
              data-aos-duration='1200'
              data-aos-delay='200'
            >
              {/* <Skills /> */}
              <NewSkills />
            </div>
            {/* End .col */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Resume;
